/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const ResolvedHeaderWrapper = styled.div({
  alignItems: 'center',
  display: 'flex',
});

export const CollapsedHeaderWrapper = styled(ResolvedHeaderWrapper)({
  gap: '8px',
});

export const CollapseExpandButton = styled.button({
  background: 'none',
  color: 'inherit',
  border: 'none',
  padding: 0,
  font: 'inherit',
  cursor: 'pointer',
  flex: 'none',
  position: 'absolute',
  top: '5px',
  right: '8px',
  zIndex: 1,
});

export const ConversationWrapper = styled.div({
  position: 'relative',
});

// Apply 32px margin between comments and the editor
export const CommentWrapper = styled.div({
  '& > * + *': {
    marginTop: token('space.400'),
  },
});

export const DividingLine = styled.hr({
  backgroundColor: token('color.border'),
  height: '1px',
  border: 'none',
});

export const NameWrapper = styled.strong({
  marginLeft: '8px',
  marginRight: '4px',
});
